export const STATUSBAR_ITEM_SLOT_PROVIDER = 'STATUSBAR_ITEM_SLOT_PROVIDER';

export const TERMINAL_ID = 'workbench.statusbar.terminal';

export const EDITOR_STATE_ITEMS = 'status.editor.editorStateItems';

export const StatusbarExtensions = {
    Statusbar: 'workbench.contributions.statusbar',
};
